import WhatWorkedInsights from './WhatWorkedInsights.component';

export default WhatWorkedInsights;
